<template>
<div>
    <div class="col-md-12">
        <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
            <h3 class="page-header">
                <i class="fa fa fa-calculator animated bounceInDown show-info"></i>
                <span>Schedule Dues Report</span>
            </h3>
            </div>
            <div class="col-md-6 text-right" v-if="viewno == 1">
            <button @click="refresh()" class="btn btn-refresh">
                <i class="fa fa-refresh"></i>
            </button>
            </div>
            <div class="col-md-6 text-right" v-if="viewno == 2">
            <button @click="back()" class="btn btn-primary">
                <i class="fa fa-backward"></i> Back
            </button>
            </div>
        </div>
    </div>
    <div style="background-color: white" v-if="viewno==1">
        <div class="col-md-12">
            <div class="info-box bg-warning text-white" v-if="showScheduleRange">
                <div class="info-details">
                    <h4 style="margin:0">
                        Schedule Duration:
                        <span class="badge bg-primary">{{ scheduleDurationFrom }}</span>
                        to
                        <span class="badge bg-success">{{ scheduleDurationTo }}</span>
                        days
                    </h4>
                </div>
            </div>
            <div class="panel panel-cascade">
                <div class="panel-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-horizontal cascde-forms">
                                <div class="form-group CHK">
                                    <label class="col-lg-4 col-md-3 control-label">Customer Name</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="customername" type="text" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Zone<span style="color:rgba(255, 0, 0, 0.67)">*</span></label>
                                    <div class="col-lg-8 col-md-9">
                                        <select class="form-control form-cascade-control input-small" v-model="zoneid">
                                            <option selected="selected" value="">SELECT</option>
                                            <option v-for="item in getmastertype(MASTER_ZONE_TYPES)" :key="item.labelid" :value="item.labelid">{{item.label}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Emi Date: FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="emidatefrom" type="date" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Due Date :FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="duedatefrom" type="date" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Bucket: FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="bucketdatefrom" type="text" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Remaining: FROM</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="remfrom" type="number" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Distance</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="distance" type="number" min="0" step="any" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 CHK">
                            <div class="form-horizontal cascde-forms">
                                <div class="form-group CHK">
                                    <label class="col-lg-4 col-md-3 control-label">Customer Mobile</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="mobile" type="number" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Customer LAN</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="manualid" type="text" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Emi Date : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="emidateto" type="date" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Due Date : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="duedateto" type="date" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Bucket : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="bucketdateto" type="text" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-lg-4 col-md-3 control-label">Remaining : TO</label>
                                    <div class="col-lg-8 col-md-9">
                                        <input class="form-control form-cascade-control input-small" v-model="remto" type="number" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-lg-12 col-md-9">
                                        <button class="btn btn-primary" @click="refresh()">Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 pt-20 panel">
            <div class="flex-between-row panel-body">
                <div class="">
                    <input
                        type="button"
                        id="btnprint"
                        class="btn bg-success btn-xs text-white"
                        :disabled="pdfloading"
                        :value="pdfloading ? 'Generating PDF...' : 'Get PDF'"
                        @click="generateReport()"
                    />
                </div>
                <div class="">
                    <span class="control-label">Total Rec:</span>
                    <span class="badge bg-seagreen">
                        <i class="fa fa-inr"></i>{{ scheduleloanemicount }}</span>
                </div>
                <!-- <div class="">
                    <span class="control-label">Total Over Dues Amount:</span>
                    <span class="badge bg-seagreen font-14"><i class="fa fa-inr"></i>{{totalduescount}}</span>
                </div>
                <div class="">
                    <span class="control-label">Total Emi Amount:</span>
                    <span class="badge bg-seagreen font-14"><i class="fa fa-inr"></i>{{totalemiamount}}</span>
                </div>
                <div class="">
                    <span class="control-label">Total Rem. Amount:</span>
                    <span class="badge bg-danger font-14"><i class="fa fa-inr"></i>{{remainingamount}}</span>
                </div> -->
            </div>
        </div>
        <div class="col-md-12">
            <div class="col-md-12 mt-20">
                <div class="row">
                    <div class="col-md-2">
                        <strong>Show Rec.</strong>
                    </div>
                    <div class="col-md-2">
                        <select class="form-control col-mb-1" v-model="noofrec" id="rec" @change="refresh()">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div>
                        <button class="btn btn-primary" @click="exportExcel()">Export</button>
                    </div>
                </div>
            </div>
            <div class="panel">
                <div class="table-responsive panel-body">
                    <table class="table users-table table-condensed table-hover table-sm table-bordered">
                        <thead class="table-font">
                        <tr>
                            <th>#</th>
                            <th>LAN No.</th>
                            <th>Customer Name</th>
                            <th>Zone</th>
                            <th>Contact</th>
                            <th>Address</th>
                            <th>Distance</th>
                            <th>Product</th>
                            <th>Emi Amt</th>
                            <th>Rating</th>
                            <th>Rem. Amt</th>
                            <th>Emi Date</th>
                            <th>Due Date</th>
                            <th>Message</th>
                            <th>Bucket</th>
                            <th>Day of Delay</th>
                            <th>Fallow By</th>
                            <th>Cust.Type</th>
                            <th>Re-Pay.Type</th>
                            <th v-if="loginusercheck(157)">Acc.Status</th>
                        </tr>
                        </thead>
                        <dues-row v-for="(item,index) in scheduleloanemi" :key="item.id"
                            :item="item" :index="index" :currentpage="currentpage" :noofrec="noofrec"
                            :overdues="overduefetch" :comments="visitcomment"></dues-row>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-12" style="margin-top: 20px">
            <nav aria-label="Page navigation example" style="text-align: right !important">
            <paginate
                style="margin: 0px !important; float: right"
                :page-count="noofpages"
                :click-handler="clickCallback"
                :prev-text="'&laquo;'"
                :next-text="'&raquo;'"
                :container-class="'pagination'">
            </paginate>
            </nav>
        </div>
    </div>
</div>
</template>
<script>
import Paginate from "vuejs-paginate";
import Constants from "../../components/utilities/Constants.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import DuesRow from "./DuesRow.vue";

export default {
    mixins: [Constants],
    components: {
        Paginate,
        DuesRow
    },
    data() {
        return {
            checkedCategories: [],
            moment: moment,
            currentpage: 1,
            noofrec: 10,
            searchrec: [],
            mobile: '',
            customername: '',
            manualid: '',
            emidateto: '',
            emidatefrom: '',
            zoneid: '',
            employeeids: '',
            duedatefrom: '',
            duedateto: '',
            bucketdatefrom: '',
            bucketdateto: '',
            totalschedule: 0,
            comments: '',
            clickadvice: false,
            pagetypeid: 0,
            totalduescount: 0,
            totalemiamount: 0,
            pdfloading: false,
            overdueamount: 0,
            remainingamount: 0,
            overduefetch: [],
            loanids: [],
            emiids: [],
            visitcomment: [],
            remto: '',
            remfrom: '',
            distance: '',
            scheduleDurationFrom: 0,
            scheduleDurationTo: 7
        };
    },
    computed: {
        ...mapGetters(["edititem", "viewno", "scheduleloanemicount", "scheduleloanemi", "attributes", "accountstatus", "loanaccounttype", "sumofremainingamount", "loggedinuser"]),
        showScheduleRange() {
            return this.loggedinuser && (this.loggedinuser.isemployee === 1 || this.loggedinuser.role <= 1);
        },
        noofpages() {
            return Math.ceil(parseInt(this.scheduleloanemicount) / parseInt(this.noofrec));
        },
    },
    mounted() {
        this.loadScheduleDuration();
        this.refresh();
        this.$store.dispatch("fetchattributes");
        this.$store.dispatch('fetchsumofremainingamount');
    },
    methods: {
        duesParams() {
            return {
                mobile:this.mobile,customername:this.customername,manualid:this.manualid,
                accountstatus:this.pagetypeid,zoneid:this.zoneid,emidatefrom:this.emidatefrom,
                emidateto:this.emidateto,empid:this.checkedCategories,duedatefrom:this.duedatefrom,
                duedateto:this.duedateto,remto:this.remto,remfrom:this.remfrom,
                bucketdatefrom:this.bucketdatefrom,bucketdateto:this.bucketdateto,
                distance:this.distance,schedule:1
            };
        },
        async loadScheduleDuration() {
            if (!this.showScheduleRange) {
                return;
            }

            try {
                const response = await this.$http.get('api/loan/schedule/duration');
                const fromDays = Number(response?.data?.schedule_duration_from ?? 0);
                const toDays = Number(response?.data?.schedule_duration_to ?? response?.data?.days ?? 7);
                this.scheduleDurationFrom = Number.isFinite(fromDays) && fromDays >= 0 ? fromDays : 0;
                this.scheduleDurationTo = Number.isFinite(toDays) && toDays > 0 ? toDays : 7;
            } catch (error) {
                this.scheduleDurationFrom = 0;
                this.scheduleDurationTo = 7;
            }
        },
        clickCallback(currentpage) {
            this.currentpage = currentpage;
            this.$store.commit("assigncurrentpage", currentpage);
            // the count doesn't change between pages
            this.refresh(true);
        },
        async refresh(rowsonly = false) {
            this.$store.commit("assignloadingstatus",1);
            // permission check and "own records" filter need the logged-in user
            const user = await this.waitForLoggedInUser();
            if(!this.loginusercheck(159) && user?.id && !this.checkedCategories.includes(user.id)){
                this.checkedCategories.push(user.id);
            }
            const param = {...this.duesParams(), currentpage:this.currentpage, noofrec:this.noofrec, rowsonly: rowsonly ? 1 : 0};

            window.axios.post('api/vsdigi/dues/list', param)
                .then((response) => this.processsearchResponse(response.data))
                .catch((err) => {
                    console.log('', err);
                    this.$store.commit("assignloadingstatus",0);
                });
        },
        processsearchResponse(data){
            this.$store.commit("assignloadingstatus",0);
            if(data.count !== undefined){ // absent on page clicks (rowsonly)
                this.$store.commit("assignscheduleloanemicount",data.count);
            }
            this.$store.commit("assignscheduleloanemi",data.emis);
            this.totalduescount = data.overdue ?? 0;
            this.totalemiamount = data.emiamount ?? 0;
            this.remainingamount = data.remainingamount ?? 0;
            if(data!=null){
                this.loanids = data.emis.map(a => a.loanemi != null ? a.loanemi.loanaccountid : null).filter(Boolean);
                this.emiids = data.emis.map(a => a.emiid);
            }
            let param = { loanid: this.loanids.join() };
            this.$http.post("api/vsdigi/dues/overdue-by-loan", param)
                .then((response) => this.ProcessResonseFetchOverdue(response.data))
                .catch((err) => console.log("", err));
            let param1 = { emiid : this.emiids.join() };
            this.$http.post("api/loan/emi/visitcomments/last/record", param1)
                .then((response) => this.ProcessResonseFetchComment(response.data))
                .catch((err) => console.log("", err));
        },
        ProcessResonseFetchOverdue(data){
            this.overduefetch = data;
            this.$store.commit("assignloadingstatus",0);
        },
        ProcessResonseFetchComment(data){
            this.visitcomment = data;
        },
        exportExcel() {
            let param = {
                mobile:this.mobile,currentpage:this.currentpage,noofrec:this.noofrec,
                customername:this.customername,manualid:this.manualid,accountstatus:this.pagetypeid,
                zoneid:this.zoneid,emidatefrom:this.emidatefrom,emidateto:this.emidateto,
                empid:this.checkedCategories,duedatefrom:this.duedatefrom,duedateto:this.duedateto,
                remto:this.remto,remfrom:this.remfrom,bucketdatefrom:this.bucketdatefrom,bucketdateto:this.bucketdateto,
                distance:this.distance,schedule_report:1
            };
            this.$http({
                url: 'api/dues/report/exportdata',
                method: 'post',
                responseType: 'blob',
                data: param,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    mode: 'no-cors'
                }
            }).then(response => {
                let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'ScheduleDuesReport.xlsx';
                link.click();
            });
        },
        async generateReport () {
            if(this.pdfloading) return;
            this.pdfloading = true;
            try {
                const response = await window.axios.post(
                    'https://ss.graddev.in/api/vsdg/dues-report',
                    this.duesParams(),
                    { responseType: 'blob' }
                );
                const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'schedule-dues-report.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
                window.URL.revokeObjectURL(fileURL);
            } catch (error) {
                console.log(error);
                this.$notify({text:'Unable to generate schedule dues report PDF',type:'error'});
            } finally {
                this.pdfloading = false;
            }
        },
        back() {
            this.$store.commit("assignviewno", 1);
        },
    }
}
</script>
<style scoped>
.form-group {
    margin-bottom: 0.1rem;
}
</style>
